import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=a4725a6c&scoped=true"
import script from "./storage.vue?vue&type=script&lang=ts"
export * from "./storage.vue?vue&type=script&lang=ts"
import style0 from "./storage.vue?vue&type=style&index=0&id=a4725a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4725a6c",
  null
  
)

export default component.exports